import * as requestFromServer from './transfersCrud';
import {transfersSlice, callTypes} from './transfersSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from 'uuid';

export const getTransfersListIDPrefix = 'getTransfersList';
const {actions} = transfersSlice;

const getTransfersList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getTransfersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .getTransfers(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalTransfersCount, transfersList, pageCount}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalCount: totalTransfersCount,
        pageCount: pageCount,
        entities: transfersList,
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find transfers';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const getTransfers = getTransfersList(actions.transfersFetched);
export const getNextTransfers = getTransfersList(actions.transfersAppended);

export const getTransfersListForExcelFile = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getTransfersForExcelFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data?.transfersList ? data?.transfersList : [];
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get data!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

